import { useMemo } from 'react';

import { SEARCH_PARAMS } from '@sorare/core/src/components/search/InstantSearch/types';
import { LIFECYCLE } from '@sorare/core/src/hooks/useLifecycle';
import { useQueryString } from '@sorare/core/src/hooks/useQueryString';
import { useTitleAndDescription } from '@sorare/core/src/hooks/useTitleAndDescription';
import { useTour } from '@sorare/core/src/hooks/useTour';
import {
  SaleType,
  TOKENS_STACKED_LIMIT,
  createCardSorts,
} from '@sorare/core/src/lib/algolia';
import { metadatas } from '@sorare/core/src/lib/seo/nba';

import { MarketRoot } from '@sorare/marketplace/src/components/market/ui';
import { useDefaultFilters } from '@sorare/marketplace/src/hooks/useDefaultFilters';
import { secondaryMarketFilters } from '@sorare/marketplace/src/searchCards/nba/cardFilters';

import { NBACardSearch } from 'components/searchCards/NBACardSearch';

const SecondaryMarket = () => {
  useTitleAndDescription(
    metadatas.transfers.title,
    metadatas.transfers.description
  );
  const unstacked = useQueryString(SEARCH_PARAMS.UNSTACKED);

  const cardSorts = useMemo(
    () =>
      createCardSorts({
        indexPrefix: 'Cards On Sale',
        withBestValue: true,
        withHighestPrice: false,
        withHighestAverageScore: true,
        withPopularPlayer: true,
        withEndingSoon: false,
      }),
    []
  );

  const defaultSort = 'Cards On Sale Popular Player';

  const filters = useDefaultFilters({
    secondary: true,
  });

  const displayStackedView = !unstacked;

  return (
    <MarketRoot>
      <NBACardSearch
        sorts={cardSorts}
        defaultSort={defaultSort}
        cardFilters={secondaryMarketFilters}
        defaultFilters={filters}
        analyticsTags={['TransferMarket', 'NBA']}
        removeEndedSingleSaleOffers
        distinct={displayStackedView ? TOKENS_STACKED_LIMIT : false}
        filtersTour={useTour(LIFECYCLE.transferMarket, 'filters')}
        cardsTour={useTour(LIFECYCLE.transferMarket, 'cards')}
        stackableTypes={[SaleType.SINGLE_SALE_OFFER]}
      />
    </MarketRoot>
  );
};
export default SecondaryMarket;
